import React, { useState } from "react";
import { ClipboardCheck, Ban } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";

/** "Record Interview Outcome" is deliberately a single explicit entry point that leads to two
 * unambiguous choices - never a vague "Manage" action. Only reachable for a CONFIRMED
 * interview (interview_scheduling_service.mark_completed/mark_no_show both enforce this
 * server-side too). */
export const RecordOutcomeDialog = ({ open, onOpenChange, onComplete, onNoShow }) => {
  const [submitting, setSubmitting] = useState(false);

  const run = async (fn) => {
    setSubmitting(true);
    try {
      await fn();
    } catch (e) {
      // Error is already surfaced via toast by the page-level action helper - keep the
      // dialog open so the recruiter can retry.
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(next) => !submitting && onOpenChange(next)}>
      <DialogContent className="max-w-sm" data-testid="record-outcome-dialog">
        <DialogHeader>
          <DialogTitle>Record Interview Outcome</DialogTitle>
          <DialogDescription>Choose exactly what happened at the confirmed interview time.</DialogDescription>
        </DialogHeader>
        <div className="flex gap-2">
          <button
            data-testid="record-outcome-completed"
            disabled={submitting}
            onClick={() => run(onComplete)}
            className="flex-1 flex items-center justify-center gap-2 py-2.5 rounded-full bg-blue-950 text-white text-sm font-semibold hover:bg-blue-900 disabled:opacity-50"
          >
            <ClipboardCheck size={15} /> Mark Completed
          </button>
          <button
            data-testid="record-outcome-no-show"
            disabled={submitting}
            onClick={() => run(onNoShow)}
            className="flex-1 flex items-center justify-center gap-2 py-2.5 rounded-full border border-red-300 text-red-600 text-sm font-semibold hover:bg-red-50 disabled:opacity-50"
          >
            <Ban size={15} /> Mark No-Show
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
